import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

import {
  Link,
  MessageBar,
  MessageBarType,
  Stack,
  SubmissionFormButtons,
  useTheme
} from "@bps/fluent-ui";
import { FormSelectorsSelect } from "@components/form/fields/FormSelectorsSelect";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { BulkActionResponse } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { BulkActionResult } from "./BulkActionResult";

interface BulkActionFormWrapperProps {
  responseMessage: BulkActionResponse | undefined;
  showSubmit?: boolean;
  requiredPermission?: Permissions;
}

export const BulkActionFormWrapper = ({
  responseMessage,
  showSubmit,
  requiredPermission = Permissions.PltFieldManagementWrite,
  children
}: PropsWithChildren<BulkActionFormWrapperProps>) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: hasRequiredPermission } = usePermissionsCheckQuery(
    requiredPermission
  );

  return (
    <Stack verticalAlign="center" tokens={{ childrenGap: theme.spacing.m }}>
      <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
        <Stack
          horizontal
          styles={{
            root: { justifyContent: "space-between" }
          }}
          tokens={{ childrenGap: theme.spacing.m }}
        >
          <Stack
            styles={{ root: { width: "30%", minWidth: 300 } }}
            tokens={{ childrenGap: theme.spacing.m }}
          >
            <FormSelectorsSelect label="Selector" name="selectorId" required />
            <MessageBar messageBarType={MessageBarType.info}>
              Or create a new selector on the{" "}
              <Link onClick={() => navigate("/system/plt/selectors")}>
                selectors
              </Link>{" "}
              page.
            </MessageBar>
          </Stack>

          <BulkActionResult response={responseMessage} />
        </Stack>
      </Stack>
      {children}

      {showSubmit !== false && (
        <SubmissionFormButtons
          hideCancelButton
          submitButtonProps={{
            text: "Submit",
            title: !hasRequiredPermission ? NO_ACTION_PERMISSION : undefined,
            ...(!hasRequiredPermission ? { disableOverride: true } : {})
          }}
        />
      )}
    </Stack>
  );
};
